import { DateTime } from "luxon"

import { getKPIRequest } from "@/api/getKPIRequest"
import type { KPIGroupRequest } from "@/types/kpiTypes"

export const getDigester7Days = async (asOf: Date) => {
  const req: KPIGroupRequest = {
    asOf,
    returnSize: 7,
    kpis: [
      {
        $type: "basic",
        typeId: 1,
        id: 45,
      },
      {
        $type: "basic",
        typeId: 1,
        id: 46,
      },
      {
        $type: "basic",
        typeId: 1,
        id: 40,
      },
    ],
  }

  const [flow, volume, scfm] = await getKPIRequest(req)

  const startDate = DateTime.fromJSDate(asOf).minus({ days: 6 })

  const vals: Record<number, { hrt: number; scfm: number; feeding: number }> = {}

  for (let i = 0; i < 7; i++) {
    const currentDate = startDate.plus({ days: i }).toISODate()
    const dayFlows = flow.values ? flow.values.filter((v) => v.date == currentDate) : []
    const dayVols = volume.values ? volume.values.filter((v) => v.date == currentDate) : []
    const daySCFM = scfm.values ? scfm.values.filter((v) => v.date == currentDate) : []

    dayFlows.forEach((df) => {
      const vol = dayVols.find((v) => v.dimensionKey == df.dimensionKey)
      const gasFlow = daySCFM.find((v) => v.dimensionKey == df.dimensionKey)
      let hrt = 0
      if (vol?.value && df.value > 0) {
        hrt = vol.value / df.value
      }
      if (vals[Number(df.dimensionKey)]) {
        vals[Number(df.dimensionKey)].hrt += hrt / 7
        vals[Number(df.dimensionKey)].scfm += (gasFlow?.value || 0) / 7
        vals[Number(df.dimensionKey)].feeding += (df?.value || 0) / 7
      } else {
        vals[Number(df.dimensionKey)] = {
          hrt: hrt / 7,
          scfm: (gasFlow?.value || 0) / 7,
          feeding: (df?.value || 0) / 7,
        }
      }
    })
  }

  return vals
}
